import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { animated, useSpring } from 'react-spring';

import { useMeasure } from '../../utils';
import { FilterBox } from '../../table';

const FilterBoxAnimated = ({
  filterBoxProps,
  filtersAreVisible,
  rightElement,
  toggledFirstTime,
  withHorizontalMargin,
  withHorizontalPadding,
  withoutBorder,
}) => {
  const inputEl = useRef(null);
  const { height } = useMeasure(inputEl);

  const transitions = useSpring({
    config: { duration: 100 },
    height: filtersAreVisible ? height : 0,
    opacity: filtersAreVisible ? 1 : 0,
    pointerEvents: filtersAreVisible ? 'auto' : 'none',
  });
  const styles = toggledFirstTime ? transitions : { ...transitions, height, opacity: 1 };

  return (
    <animated.div style={styles}>
      <FilterBox
        {...filterBoxProps}
        inputRef={inputEl}
        rightElement={rightElement}
        withHorizontalMargin={withHorizontalMargin}
        withHorizontalPadding={withHorizontalPadding}
        withoutBorder={withoutBorder}
      >
        {filterBoxProps.children}
      </FilterBox>
    </animated.div>
  );
};

FilterBoxAnimated.propTypes = {
  filterBoxProps: PropTypes.shape({ children: PropTypes.node }),
  filtersAreVisible: PropTypes.bool,
  rightElement: PropTypes.node,
  toggledFirstTime: PropTypes.bool,
  withHorizontalMargin: PropTypes.bool,
  withHorizontalPadding: PropTypes.bool,
  withoutBorder: PropTypes.bool,
};
FilterBoxAnimated.defaultProps = {
  filterBoxProps: {},
};

export default FilterBoxAnimated;
